<template>
  <section class="nf-page">
    <div class="nf-hero">
      <h1>Faqs</h1>
      <p>Common questions about creating and discovering flyers.</p>
    </div>
    <ul class="nf-list">
      <li><strong>Can I edit a flyer?</strong><p class="nf-muted">Yes. Open your created list and choose edit.</p></li>
      <li><strong>Can I save flyers?</strong><p class="nf-muted">Yes. Saved flyers are available from your account navigation.</p></li>
      <li><strong>Can I filter by location?</strong><p class="nf-muted">Yes. Explore includes a location picker.</p></li>
    </ul>
  </section>
</template>
